import {
  Button,
  CircularProgress,
  InputAdornment,
  Paper,
  TextField,
} from '@material-ui/core';
import WeightDialog from 'components/Dialog/WeightDialog/WeightDialog';
import SelectState from 'components/FormInputs/SelectCity';
import SelectCargo from 'components/Select/SelectCargo';
import React, { useEffect, useState } from 'react';
import tonnageIcon from 'assets/svg/tonnage.svg';
import FleetsTextFields from 'components/TextFields/FleetsTextFields';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import { useFreight } from 'useStores/useFreight';
import { __ } from 'utils/i18n';
import { formatNumber } from 'fns';
import { toEN } from 'fns';
import useValidator from 'hooks/useValidator';
import { TYPES } from 'hooks/useValidator';
import axios from 'api/axios';
import useToast from 'hooks/useToast';
import PriceWithLabel from 'components/TextFields/PriceWithLabel';
import CallIcon from '@material-ui/icons/Call';

const OrderForm = () => {
  const toast = useToast();
  const [weightDialog, setWeightDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const cargo = useFreight((state) => state.addOrderItems.cargoType);
  const orderItems = useFreight((state) => state.addOrderItems);
  const setOrderItems = useFreight((state) => state.setOrderItems);
  const choosedFreight = useFreight((state) => state.choosedFreight);
  const resetNewOrderForm = useFreight((state) => state.resetNewOrderForm);

  const validators = {
    origin: [{ type: TYPES.REQUIRED }],
    destination: [{ type: TYPES.REQUIRED }],
    cargoType: [{ type: TYPES.REQUIRED }],
    weight: [{ type: TYPES.REQUIRED }],
    fleetType: [{ type: TYPES.REQUIRED }],
    basePrice: [{ type: TYPES.REQUIRED }],
    phoneNumber: [{ type: TYPES.REQUIRED }],
  };
  const [errors, validate] = useValidator(validators);

  const handleClose = (data) => {
    changeFildes(data.weight, 'weight');
    changeFildes(data.weightType, 'weightType');
    setWeightDialog(false);
  };

  const changeFildes = (data, field) => {
    if (field === 'fleetType') {
      setOrderItems(data?.map((item) => item.fleet._id));
    }
    setOrderItems(data, field);
  };

  const submitForm = async () => {
    try {
      setLoading(true);
      if (
        validate({
          origin: orderItems.origin,
          destination: orderItems.destination,
          cargoType: orderItems.cargoType,
          weight: orderItems.weight,
          fleetType: orderItems.fleetType.length > 0,
          // basePrice: orderItems.basePrice,
          phoneNumber: orderItems.phoneNumber,
        })
      ) {
        const _data = {
          freight: choosedFreight._id,
          origin: orderItems.origin._id,
          destination: orderItems.destination._id,
          cargoType: orderItems.cargoType._id,
          weight: orderItems.weight,
          weightType: orderItems.weightType, // Ton or Kg
          fleetOptions: orderItems.fleetType?.map((item) => item?._id),
          basePrice: toEN(orderItems.basePrice),
          priceBasedWeight:
            orderItems.priceBasedWeight === 'perTon' ? true : false,
          description: orderItems?.description,
          phone: orderItems?.phoneNumber,
        };
        const res = await axios.post('/api/v1/admin/freight/newOrder', _data);
        if (res.data.ok) {
          toast.success('سفارش با موفقیت ثبت شد');
          resetNewOrderForm();
        }
      } else {
        throw 'فیلدهای مشخص شده را اصلاح فرمائید';
      }
    } catch (error) {
      toast.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="row g-3 mt-3">
      <div className="col-sm-6 col-12">
        <SelectState
          name={'origin'}
          city={orderItems.origin || null}
          onSelect={(data) => changeFildes(data, 'origin')}
          placeholder={'انتخاب مبدا بارگیری'}
          error={errors?.origin || false}
          helperText={errors?.origin ? 'نام شهر را بایستی وارد نمائید' : ''}
        />
      </div>
      <div className="col-sm-6 col-12">
        <SelectState
          city={orderItems.destination || null}
          onSelect={(data) => changeFildes(data, 'destination')}
          placeholder={'انتخاب مقصد'}
          error={errors?.destination || false}
          helperText={
            errors?.destination ? 'نام شهر را بایستی وارد نمائید' : ''
          }
        />
      </div>
      <div className="col-sm-6 col-12">
        <SelectCargo
          cargo={cargo || null}
          onSelect={(data) => changeFildes(data, 'cargoType')}
          error={errors?.cargoType || false}
          helperText={
            errors?.cargoType ? 'نوع محموله را بایستی وارد نمائید' : ''
          }
        />
      </div>
      <div className="col-sm-6 col-12">
        <TextField
          name="weight"
          onClick={() => setWeightDialog(true)}
          variant="outlined"
          color="secondary"
          placeholder="وزن محموله"
          size="small"
          label="وزن محموله"
          fullWidth
          defaultValue={''}
          error={errors?.weight || false}
          helperText={errors?.weight ? 'وزن محموله را بایستی وارد نمائید' : ''}
          value={`${orderItems?.weight || 0} ${__(
            orderItems?.weightType || 'Ton'
          )}`}
          InputProps={{
            readOnly: true,
            endAdornment: (
              <InputAdornment position="end">
                <img src={tonnageIcon} alt="" height={25} width={25} />
              </InputAdornment>
            ),
          }}
        />
        {weightDialog && <WeightDialog onClose={handleClose} />}
      </div>
      <div className="col-6">
        <FleetsTextFields
          name={'fleetType'}
          size={'small'}
          weight={orderItems.weight || 0}
          weightType={orderItems.weightType || 'Ton'}
          error={errors?.fleetType || false}
          helperText={
            errors?.fleetType ? 'نوع ناوگان را بایستی وارد نمائید' : ''
          }
          selection={orderItems.fleetType || []}
          onChange={(data) => {
            changeFildes(data, 'fleetType');
          }}
        />
      </div>
      <div className="col-6">
        <TextField
          name="phoneNumber"
          variant="outlined"
          color="secondary"
          placeholder="شماره تلفن جهت هماهنگی"
          size="small"
          fullWidth
          defaultValue={''}
          error={errors?.phoneNumber || false}
          value={orderItems.phoneNumber ? toEN(orderItems.phoneNumber) : ''}
          onChange={(e) => changeFildes(e.target.value, 'phoneNumber')}
          helperText={
            errors?.phoneNumber
              ? 'شماره تلفن جهت هماهنگی را بایستی وارد نمائید'
              : ''
          }
          InputProps={{
            pattern: '[0-9]*',
            endAdornment: (
              <InputAdornment position="end">
                <CallIcon />
              </InputAdornment>
            ),
          }}
        />
      </div>
      <div className="col-12">
        <div className="d-flex justify-content-between">
          {/* <TextField
            name={'basePrice'}
            error={errors?.basePrice || false}
            helperText={errors?.basePrice ? 'کرایه را بایستی وارد نمائید' : ''}
            className="w-50"
            variant="outlined"
            placeholder="صافی راننده "
            onChange={(e) => changeFildes(e.target.value, 'basePrice')}
            size="small"
            value={
              orderItems.basePrice
                ? formatNumber(toEN(orderItems.basePrice))
                : null
            }
          /> */}
          <PriceWithLabel
            error={errors?.basePrice || false}
            helperText={errors?.basePrice ? 'کرایه را بایستی وارد نمائید' : ''}
            size="small"
            rows={10}
            fullWidth
            variant="outlined"
            name="basePrice"
            value={orderItems.basePrice ? toEN(orderItems.basePrice) : ''}
            onChange={(e) => changeFildes(e.target.value, 'basePrice')}
            label="صافی راننده"
            position="down"
          />
          <FormControl className="w-50" component="fieldset">
            <RadioGroup
              className="justify-content-center"
              row
              aria-label="position"
              name="position"
              defaultValue="totalFee"
              value={orderItems?.priceBasedWeight || 'totalFee'}
              onChange={(e) => changeFildes(e.target.value, 'priceBasedWeight')}
            >
              <FormControlLabel
                value="totalFee"
                control={<Radio color="primary" />}
                label="کرایه کل"
                labelPlacement="end"
              />
              <FormControlLabel
                value="perTon"
                control={<Radio color="primary" />}
                label="هر تن"
                labelPlacement="end"
              />
            </RadioGroup>
          </FormControl>
        </div>
      </div>
      <div className="col-12">
        <TextField
          value={orderItems.description || ''}
          variant="outlined"
          color="secondary"
          placeholder="توضیحات"
          onChange={(e) => changeFildes(e.target.value, 'description')}
          fullWidth
          rows={5}
          multiline
        />
      </div>
      <div className="col-12">
        <Button
          onClick={submitForm}
          fullWidth
          variant="contained"
          color="primary"
          disabled={loading}
          endIcon={loading && <CircularProgress size={10} />}
        >
          افزودن سفارش
        </Button>
      </div>
    </div>
  );
};

export default OrderForm;
